import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { FormikInputPassword } from '@/general/components/forms/FormikInput/FormikInputPassword';
import { getMicrocopy } from '@/stores/microcopyStore';
import { encodeHTMLEntities } from '@/utils/encodeHTMLEntities';

import styles from './PersonalizedQuoteForm.module.scss';
import { PersonalizedQuoteFormProps, SigninFormValidation, SigninFormValues } from './PersonalizedQuoteForm.type';

const initialValues: SigninFormValues = {
  password: '',
};

export const SignInForm: FC<PersonalizedQuoteFormProps<SigninFormValues> & { email: string }> = ({
  email,
  onClickResetPassword,
  onSubmit,
  values,
  onBack,
}) => (
  <>
    <div className={styles.checkoutDescription}>
      <CheckoutDescription
        title={getMicrocopy(MICROCOPY.AUTHENTICATION_SIGNIN_FORM_TITLE)}
        description={getMicrocopy(MICROCOPY.AUTHENTICATION_SIGNIN_FORM_CAPTION, true, {
          email: encodeHTMLEntities(email),
        })}
        onBack={onBack}
      />
    </div>
    <div className={styles.signInForm}>
      <Formik
        initialValues={{ ...initialValues, ...values }}
        validateOnBlur={false}
        onSubmit={onSubmit}
        validationSchema={SigninFormValidation}
      >
        {(props) => (
          <Form className={styles.form} noValidate>
            <FormikInputPassword
              name="password"
              label="Password"
              data-testid="password-input"
              disabled={props.isSubmitting}
              autoFocus
            />
            <div className={styles.formForgotPassword}>
              <Button
                type="button"
                variant="tertiary"
                size="small"
                onClick={onClickResetPassword}
                disabled={props.isSubmitting}
                data-testid="forgotPassword"
              >
                {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_SIGN_IN_FORM_FORGOT_PASSWORD_CTA)}
              </Button>
            </div>
            <footer className={styles.footer}>
              <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                {getMicrocopy(MICROCOPY.GENERAL_HEADER_LOGIN_BUTTON_LABEL)}
              </Button>
            </footer>
          </Form>
        )}
      </Formik>
    </div>
  </>
);
